import styled, { DefaultTheme, keyframes } from "styled-components";
import { getColor } from "../../../utils/color";

export interface ColorProps {
  backgroundColor: keyof DefaultTheme["colors"] | "transparent";
  primaryColor: keyof DefaultTheme["colors"] | string;
  secondaryColor: keyof DefaultTheme["colors"] | string;
}

export const SelectContainer = styled.div<ColorProps>`
  position: relative;
  display: flex;
  align-items: center;
  border-radius: 0.5rem;
  border: 1px solid ${({ primaryColor }) => getColor(primaryColor).main};
  padding: 0 1rem;
  gap: 0.5rem;
  margin: 0.75rem 0;

  svg {
    color: ${({ theme, primaryColor }) => getColor(primaryColor).main};
  }

  input {
    flex: 1;
    background: transparent;
    border: 0;
    outline: 0;
    color: ${({ theme }) => theme.colors.gray900.main};
    line-height: 2;
    height: 35px;

    &:focus {
      outline: 0;
    }

    &::placeholder {
      color: ${({ theme, secondaryColor }) => getColor(secondaryColor).main};
      font-size: 0.9rem;
    }
  }
`;

export const showAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(95%);
  }
  to {
    opacity: 1;
    transform: translateY(101%);
  }
`;

export const OptionsContainer = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateY(101%);
  max-height: 15rem;
  animation: ${showAnimation};
  animation-duration: 0.3s;
  background-color: ${({ theme }) => theme.colors.white.main};
  z-index: 10;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.12);
  border-radius: 0.5rem;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    background: transparent;
    border-radius: 8px;
    width: 0.25rem;
    margin: 1rem;
    height: 0.25rem;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: #98989c;
    border-radius: 0.5rem;
  }
`;

export const OptionsList = styled.ul`
  list-style: none;
  padding: 0;
`;

export const Option = styled.li`
  padding: 0.25rem 1.25rem;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.denim.main}14;
  }
`;

export const NoOption = styled(Option)`
  display: flex;
  width: 100%;
  justify-content: center;

  &:hover {
    cursor: default;
    background-color: transparent;
  }
`;
